// extracted by mini-css-extract-plugin
export default {"sourceCell":"VlApIwsqnoE_6rMXJlsq","logo":"eSjOeFOlKpoPcws8SN6W","label":"Sxeo28SorigcHq2FfBqt"};